import { render } from "./PopulationList.vue?vue&type=template&id=5d5ea2aa&scoped=true"
import script from "./PopulationList.vue?vue&type=script&lang=js"
export * from "./PopulationList.vue?vue&type=script&lang=js"

import "./PopulationList.vue?vue&type=style&index=0&id=5d5ea2aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5ea2aa"]])

export default __exports__